import { combineReducers } from "redux";
import { album } from "../reducer/album";
import { artist } from "../reducer/artist";
import { albumType } from "../reducer/albumType";
import { albumTrack } from "../reducer/albumTrack";
import { authentication } from "../reducer/authentication";
import { loading } from "../reducer/loading";
import { comment } from "../reducer/comment";

export const reducers = combineReducers({
    loading,
    album,
    artist,
    albumType,
    authentication,
    albumTrack,
    comment
})
